<ng-container *ngIf="algunaCosaAMostrar">
    <div class="partner requadre problem" *ngIf="problem">{{ 'ROUTE.MARKS.PROBLEM' | translate }}</div>
    <div class="partner requadre delayed" *ngIf="delayed">{{ 'ROUTE.MARKS.DELAYED' | translate }}</div>
    <div class="partner requadre notready" *ngIf="notready">{{ 'ROUTE.MARKS.NOTREADY' | translate }}</div>
    <div class="partner requadre urgent" *ngIf="urgent">{{ 'ROUTE.MARKS.URGENT' | translate }}</div>
</ng-container>